<template>
  <div class="content-builder">

    <div class="form-group">
      <label class="control-label">Text</label>
      <QuillEditor v-model:content="content.text" :contentType="'html'" :modules="editorModules" :toolbar="toolbarOpts"
                   theme="snow"/>
    </div>

    <div class="mb-4">
      <label class="control-label" for="input-content-classes">Text CSS Classes</label>
      <input id="input-content-classes" v-model="content.classes" class="form-control" type="text">
    </div>

    <div class="form-group">
      <label class="control-label">Question Image</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <a class="btn btn-primary text-white" data-input="question-image" data-lfm="image">
            <i class="fa fa-image"></i>
          </a>
        </div>
        <input id="question-image" v-model="content.questionImage" class="form-control" type="text">
      </div>
    </div>

    <div class="form-group">
      <label class="control-label">Grid Content</label>
      <table class="table">
        <tbody>
        <tr>
          <th scope="row">
            <input v-model="grid.labels.row[0]" class="form-control" placeholder="Axis Label" type="text">
          </th>
          <td>
            <input v-model="grid.nodes[0][0]" class="form-control mb-2" placeholder="Node Label" type="text">
            <textarea v-model="grid.text[0][0]" class="form-control mb-2" placeholder="Node Content"></textarea>
            <div class="input-group">
              <div class="input-group-prepend">
                <a class="btn btn-primary text-white" data-input="image-1" data-lfm="image">
                  <i class="fa fa-image"></i>
                </a>
              </div>
              <input id="image-1" v-model="grid.images[0][0]" class="form-control" type="text">
            </div>
          </td>
          <td>
            <input v-model="grid.nodes[0][1]" class="form-control mb-2" placeholder="Node Label" type="text">
            <textarea v-model="grid.text[0][1]" class="form-control mb-2" placeholder="Node Content"></textarea>
            <div class="input-group">
              <div class="input-group-prepend">
                <a class="btn btn-primary text-white" data-input="image-2" data-lfm="image">
                  <i class="fa fa-image"></i>
                </a>
              </div>
              <input id="image-2" v-model="grid.images[0][1]" class="form-control" type="text">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">
            <input v-model="grid.labels.row[1]" class="form-control" placeholder="Axis Label" type="text">
          </th>
          <td>
            <input v-model="grid.nodes[1][0]" class="form-control mb-2" placeholder="Node Label" type="text">
            <textarea v-model="grid.text[1][0]" class="form-control mb-2" placeholder="Node Content"></textarea>
            <div class="input-group">
              <div class="input-group-prepend">
                <a class="btn btn-primary text-white" data-input="image-3" data-lfm="image">
                  <i class="fa fa-image"></i>
                </a>
              </div>
              <input id="image-3" v-model="grid.images[1][0]" class="form-control" type="text">
            </div>
          </td>
          <td>
            <input v-model="grid.nodes[1][1]" class="form-control mb-2" placeholder="Node Label" type="text">
            <textarea v-model="grid.text[1][1]" class="form-control mb-2" placeholder="Node Content"></textarea>
            <div class="input-group">
              <div class="input-group-prepend">
                <a class="btn btn-primary text-white" data-input="image-4" data-lfm="image">
                  <i class="fa fa-image"></i>
                </a>
              </div>
              <input id="image-4" v-model="grid.images[1][1]" class="form-control" type="text">
            </div>
          </td>
        </tr>
        <tr>
          <th>&nbsp;</th>
          <th scope="col">
            <input v-model="grid.labels.col[0]" class="form-control" placeholder="Axis Label" type="text">
          </th>
          <th scope="col">
            <input v-model="grid.labels.col[1]" class="form-control" placeholder="Axis Label" type="text">
          </th>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="mb-4">
      <label class="control-label" for="input-grid-classes">Grid CSS Classes</label>
      <input id="input-grid-classes" v-model="grid.classes" class="form-control" type="text">
    </div>

    <div class="mb-4">
      <label class="control-label" for="input-grid-text-classes">Grid Text Box CSS Classes</label>
      <input id="input-grid-text-classes" v-model="grid.textClasses" class="form-control" type="text">
    </div>

    <div class="mb-4">
      <label class="control-label" for="input-image-overlay-style">Image Overlay Style</label>
      <input id="input-image-overlay-style" v-model="grid.imageOverlay" class="form-control"
             placeholder="radial-gradient(circle at 50% 50%, rgba(255, 255, 45, 0.6) 0%, rgba(255, 0, 255, 0.6) 100%)"
             type="text">
    </div>

    <div class="mb-4">
      <div class="row">
        <div class="col">
          <label class="control-label" for="input-grid-item-text-color">Grid Item Text Color</label>
          <input id="input-grid-item-text-color" v-model="grid.gridItemTextColor" class="form-control"
                 placeholder="#FFFFFF"
                 type="text">
        </div>
        <div class="col">
          <label class="control-label" for="input-grid-item-text-shadow">Enable Grid Item Text Shadow</label>
          <input id="input-grid-item-text-shadow" v-model="grid.gridItemTextShadow" class="d-block" type="checkbox">
        </div>
      </div>
    </div>

    <div class="mb-4">
      <label class="control-label" for="input-grid-label-text-color">Grid Label Text Color</label>
      <input id="input-grid-label-text-color" v-model="grid.gridLabelTextColor" class="form-control"
             placeholder="#304d93"
             type="text">
    </div>

    <div class="mb-4">
      <label class="control-label" for="input-grid-content-text-color">Grid Content Text Color</label>
      <input id="input-grid-content-text-color" v-model="grid.gridContentTextColor" class="form-control"
             placeholder="#304d93"
             type="text">
    </div>

    <div class="mb-4">
      <label class="control-label" for="input-grid-content-border-color">Grid Content Border Color</label>
      <input id="input-grid-content-border-color" v-model="grid.gridContentBorderColor" class="form-control"
             placeholder="#dca63a"
             type="text">
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {defaultMeters} from '../../../common/metrics'
import layoutMixin from '../../mixins/layout'
import {EDITOR_CONFIG_BUTTONS_FULL} from '../../../common/constants'
import {QuillEditor} from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

const DEFAULT_GRID = {
  labels: {
    row: [],
    col: []
  },
  nodes: [[], []],
  text: [[], []],
  images: [[], []],
  imageOverlay: ''
}

export default {
  components: {
    QuillEditor
  },
  mixins: [layoutMixin],
  data() {
    const content = _.cloneDeep(this.source)

    content.grid = _.assign({}, DEFAULT_GRID, content.grid)

    return {
      SIZE: 2,
      content: content,
      toolbarOpts: EDITOR_CONFIG_BUTTONS_FULL
    }
  },
  computed: {
    grid() {
      return this.content.grid
    }
  },
  methods: {
    setContent() {
      console.log('Grid::setContent')
    },
    getValue() {
      return this.content
    }
  }
}
</script>

<style lang="scss">

</style>
